import { render, staticRenderFns } from "./KabMamberamoRaya.vue?vue&type=template&id=0c8833c1"
import script from "./KabMamberamoRaya.vue?vue&type=script&lang=js"
export * from "./KabMamberamoRaya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports